export enum EViewerAside
{
  VIDEO = 1,
  //ZOOM = 2,
  GUIDE = 3,
  CHAT = 4,
  HELP = 5,
  CLOSE_HELP = 6,
}
